import { UX2 } from '@wsb/guac-widget-core';

// Registers `UX2.Component.ReviewerAvatar` and `UX2.Component.ReviewerInitial`
// as React component classes that delegate to the active theme's slot
// implementations defined in `Themes/Default/Components/Reviews/ReviewerAvatar.js`.
// Themes (e.g. layout31) can override either slot to scope an avatar
// treatment to themselves; defaults reproduce the legacy gray rendering
// so themes that don't override see no change.
export class ReviewerAvatar extends UX2.utils.createElement('ReviewerAvatar') {}
export class ReviewerInitial extends UX2.utils.createElement('ReviewerInitial') {}
